//
import { API } from "../../api";
async function update_quantity(request) {
    // console.log("update_quantity -> request", request);
    return await new API().apiPut({
        baseUrl: process.env.LETS_TRADE_BASKET_URL ?? "",
        endpoint: `v2/update/product`,
        content: request,
    });
}
export { 
// IUpdateQuantityRequest,
update_quantity, };
